import { TrafikenConfig } from '../TrafikenConfig';
import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';

const defaultOptions = (region) => ({
    id: 'travel-time-route-source',
    url: `${TrafikenConfig.infoLayerServiceBaseUrl}/api/traveltime/action/getsections?region=${region}`,
    showErrorToast: false,
});

export class TravelTimeSectionSource extends AjaxSource {
    constructor(region: string, options?: AjaxSourceOptions) {
        super({ ...defaultOptions(region), ...options });
    }
}
